"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormHeader = exports.FormHeaderDefaultProps = void 0;
var React = __importStar(require("react")); // tslint:disable-line
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var useMemo = React.useMemo;
var progress_1 = require("./progress");
var use_icons_1 = require("../../hooks/use-icons");
var field_set_tabs_1 = require("./field-set-tabs");
var dialog_title_1 = require("../elements/dialog-title");
exports.FormHeaderDefaultProps = {
  progressItems: [],
  icon: function () {
    return null;
  },
  onCancel: function () {},
  onChangePage: function (page) {},
  submitting: false,
  isModal: false
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    box-sizing: content-box;\n    position: relative;\n    z-index: 10;\n    background-color: ", ";\n    border-bottom: 1px solid ", ";\n  "], ["\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    box-sizing: content-box;\n    position: relative;\n    z-index: 10;\n    background-color: ", ";\n    border-bottom: 1px solid ", ";\n  "])), theme_1.theme.COLOR('app-chrome'), theme_1.theme.COLOR('line-sidebar'))
});
var BodyStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    position: relative;\n  "], ["\n    position: relative;\n  "])))
});
var ProgressStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    justify-content: flex-start;\n  "], ["\n    justify-content: flex-start;\n  "])))
});
var TabsStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    margin-top: 0px;\n    position: relative;\n    top: 1px;\n    left: 0px;\n  "], ["\n    margin-top: 0px;\n    position: relative;\n    top: 1px;\n    left: 0px;\n  "]))),
  desktop: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    margin-top: 4px;\n    ", "\n  "], ["\n    margin-top: 4px;\n    ", "\n  "])), function (props) {
    return !props.isModal && (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    "], ["\n    "])));
  })
});
var TitleStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    padding: ", " ", " ", ";\n    ", "\n  "], ["\n    padding: ", " ", " ", ";\n    ", "\n  "])), theme_1.theme.UNIT(2), theme_1.theme.UNIT(3), theme_1.theme.UNIT(2), function (props) {
    return props.isModal && (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n      padding-left: ", ";\n      padding-right: ", ";\n    "], ["\n      padding-left: ", ";\n      padding-right: ", ";\n    "])), theme_1.theme.UNIT(4), theme_1.theme.UNIT(4));
  }),
  tablet: (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    padding: ", " ", " ", ";\n    ", "\n  "], ["\n    padding: ", " ", " ", ";\n    ", "\n  "])), theme_1.theme.UNIT(3), theme_1.theme.UNIT(4), theme_1.theme.UNIT(3), function (props) {
    return props.isModal && (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n      padding-left: ", ";\n      padding-right: ", ";\n    "], ["\n      padding-left: ", ";\n      padding-right: ", ";\n    "])), theme_1.theme.UNIT(4), theme_1.theme.UNIT(4));
  }),
  desktop: (0, styled_components_1.css)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    padding: ", " ", " ", ";\n    ", "\n  "], ["\n    padding: ", " ", " ", ";\n    ", "\n  "])), theme_1.theme.UNIT(3), theme_1.theme.UNIT(4), theme_1.theme.UNIT(3), function (props) {
    return props.isModal && (0, styled_components_1.css)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n      padding-left: ", ";\n      padding-right: ", ";\n    "], ["\n      padding-left: ", ";\n      padding-right: ", ";\n    "])), theme_1.theme.UNIT(4), theme_1.theme.UNIT(4));
  })
});
var FADE_HEIGHT_BASE = 14;
var FADE_HEIGHT = 24;
var FadeStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    display: flex;\n    box-sizing: border-box;\n    width: 90%;\n    position: absolute;\n    left: 0;\n    background: linear-gradient(to bottom, rgba(255, 255, 255, 1.0) 0%, rgba(255, 255, 255, 0) 100%);\n    bottom: -", "px;\n    height: ", "px;\n  "], ["\n    display: flex;\n    box-sizing: border-box;\n    width: 90%;\n    position: absolute;\n    left: 0;\n    background: linear-gradient(to bottom, rgba(255, 255, 255, 1.0) 0%, rgba(255, 255, 255, 0) 100%);\n    bottom: -", "px;\n    height: ", "px;\n  "])), FADE_HEIGHT_BASE + 1, FADE_HEIGHT_BASE),
  tablet: (0, styled_components_1.css)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n    bottom: -", "px;\n    height: ", "px;\n\n    ", "\n  "], ["\n    bottom: -", "px;\n    height: ", "px;\n\n    ", "\n  "])), FADE_HEIGHT + 1, FADE_HEIGHT, function (props) {
    return props.isModal && (0, styled_components_1.css)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n      bottom: -", "px;\n      height: ", "px;\n    "], ["\n      bottom: -", "px;\n      height: ", "px;\n    "])), FADE_HEIGHT_BASE + 1, FADE_HEIGHT_BASE);
  })
});
var TabContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n    margin-top: ", ";\n  "], ["\n    margin-top: ", ";\n  "])), theme_1.theme.UNIT(1))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Fade: styled_components_1.default.div(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), FadeStyles),
  Body: styled_components_1.default.div(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Title: (0, styled_components_1.default)(dialog_title_1.DialogTitle)(templateObject_20 || (templateObject_20 = __makeTemplateObject(["", ""], ["", ""])), TitleStyles),
  Tabs: (0, styled_components_1.default)(field_set_tabs_1.FieldSetTabs)(templateObject_21 || (templateObject_21 = __makeTemplateObject(["", ""], ["", ""])), TabsStyles),
  Progress: (0, styled_components_1.default)(progress_1.Progress)(templateObject_22 || (templateObject_22 = __makeTemplateObject(["", ""], ["", ""])), ProgressStyles),
  TabContainer: styled_components_1.default.div(templateObject_23 || (templateObject_23 = __makeTemplateObject(["", ""], ["", ""])), TabContainerStyles)
};
// define this here to avoid recreating a reference and thus causing a prop change
var itemClickHandler = function (onChangePage) {
  return function (item, index) {
    onChangePage(index);
  };
};
var FormHeader = function (props) {
  var className = props.className,
    title = props.title,
    children = props.children,
    logo = props.logo,
    progressItems = props.progressItems,
    onCancel = props.onCancel,
    onChangePage = props.onChangePage,
    icon = props.icon,
    submitting = props.submitting,
    isModal = props.isModal,
    subTitle = props.subTitle,
    badge = props.badge;
  var icons = (0, use_icons_1.useIcons)();
  var Icon = icon({
    icons: icons
  });
  return React.createElement(My.Container, {
    className: className,
    hasProgress: progressItems.length
  }, React.createElement(My.Body, {
    isModal: isModal
  }, !submitting && React.createElement(My.Fade, {
    isModal: isModal
  }), React.createElement(My.Title, {
    isModal: isModal,
    onCancel: onCancel,
    showLogo: false,
    isCancelButtonDisabled: submitting,
    subTitle: subTitle,
    title: title,
    badge: badge,
    icon: Icon
  }, children), progressItems.length > 1 && React.createElement(My.TabContainer, null, React.createElement(My.Tabs, {
    className: 'shp--form-tabs',
    isModal: isModal,
    disabled: submitting,
    items: progressItems,
    onItemClick: itemClickHandler(onChangePage)
  }))));
};
exports.FormHeader = FormHeader;
exports.FormHeader.defaultProps = exports.FormHeaderDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23;